import React from 'react';
import { Link } from 'react-router';

import { Button } from '@any-ui-react/core';
import { VariantProps, tv } from 'tailwind-variants';

const styles = tv({
  slots: {
    root: 'mx-auto flex items-center justify-center px-14 py-10',
    content: 'flex max-w-120 min-w-70 flex-col items-center justify-center text-center',
    image: 'h-auto',
    title: 'text-gray-9 mt-6 text-lg',
    description: 'text-gray-7 mt-4 text-sm',
    button: 'mt-6',
  },
  variants: {
    size: {
      md: {
        image: 'w-32 lg:w-40',
      },
      lg: {
        image: 'w-40 lg:w-52',
      },
    },
  },
});

type ImageVariants = VariantProps<typeof styles>;

interface ConnectionFallbackProps {
  imgSrc?: string;
  imgAlt?: string;
  title: string;
  description: string;
  link?: string;
  linkLabel?: string;
  children?: React.ReactNode;
  imageSize?: ImageVariants['size'];
}

export const ConnectionFallback = ({
  imgSrc,
  imgAlt,
  title,
  description,
  link,
  linkLabel,
  children,
  imageSize = 'md',
}: ConnectionFallbackProps) => {
  const classes = styles({ size: imageSize });

  return (
    <div className={classes.root()}>
      <div className={classes.content()}>
        {imgSrc && <img loading="lazy" className={classes.image()} src={imgSrc} alt={imgAlt} />}
        <h2 className={classes.title()}>{title}</h2>
        <p className={classes.description()}>{description}</p>
        {linkLabel && link && (
          <Button component={Link} to={link} className={classes.button()}>
            {linkLabel}
          </Button>
        )}
        {children}
      </div>
    </div>
  );
};
